<template>
  <div>
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/cfmchurch_bg_011.jpg);"
      ></div>
      <div class="container">
        <h1>About <span>Us</span></h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/about">About Us</router-link></li>
        </ul>
      </div>
    </div>
    <section>
      <div class="block cmi-about">
        <div class="container">
          <div class="row">
            <div class="col-md-6 column">
              <div class="simple-text">
                <h3>WHO WE ARE</h3>
                <p>
                  <b>ChristLife Faith Ministries (CFM)</b> as a ministry takes
                  its root from Mark 11:22, which says “Have faith in God”.
                  Meaning have the faith of God in your Christian journey
                  without compromise.
                </p>
                <p>
                  This means for one to realise the grace for expansion and
                  overflow, you must live a ChristLife of Faith by focusing and
                  wholeheartedly depending on the undiluted Word of God in all
                  kinds of circumstances.
                </p>
                <p>
                  In a nutshell, “Jesus is the Centre of it All” and we are
                  known as <b>The Breakthrough Church</b>. For Jesus Christ
                  Himself said in Jeremiah 51:20 -24 “You are My battle-ax and
                  weapons of war: For with you I will break the nation in
                  pieces; With you I will destroy kingdoms;” ...
                </p>
                <p class="wow fadeInUp">
                  ChristLife Faith Ministries is a teaching, evangelistic and
                  deliverance ministry which support and empower members and the
                  community at large to endure a purposeful ChristLife way of
                  living and to build missionary disciples by teaching and
                  helping people to discover, follow, and share Jesus Christ
                  through the undiluted Word of God.
                </p>
                <p class="wow fadeInUp">
                  Our mandate is to equip the saints and members of the public
                  (Ephesians 4:12) for the essential work of ministry by arming
                  and strengthening them with the Word through Faith to
                  personally encounter Jesus Christ and to be transformed into
                  His missionary disciples by living the faith of Christ Jesus.
                </p>
                <p class="wow fadeInUp">
                  Even though you are faced with worldly trials and tribulations
                  in your Christian journey which can make you to be perplexed
                  and staggered in some cases; but having the faith of God, we
                  believe that ‘He has disarmed all principalities and powers
                  (Colossians 2:15), that the saints witness in their daily
                  lives and you will overcome all these challenges to be a
                  victor and regain your star of destiny.
                </p>
              </div>
            </div>
            <div class="col-md-6 column">
              <div class="simple-text">
                <h3>OUR BELIEF</h3>
                <p>
                  At ChristLife Faith Ministries, our teaching emphasis is
                  centred on helping and supporting our members and community at
                  large to identify “who are you” (John 1:19)? In a nutshell,
                  our members and the community are trained and empowered to
                  answer “what is your kingdom purpose” here on earth, when God
                  said “lets us make man into our image and according to our
                  likeness.
                </p>
                <p class="wow fadeInUp">
                  Let them have dominion over everything that creeps here on
                  earth (Genesis 1:26). One must fulfil this mandate in order to
                  be able to give an account when we return to glory to be with
                  our Great God as spirit.
                </p>
                <p class="wow fadeInUp">
                  This is central to our belief, because as a believer, you must
                  candidly answer these 5 deep Spiritual questions:
                </p>
                <ul class="wow fadeInUp">
                  <li>
                    <i class="fa fa-check"></i>
                    Who am I?
                  </li>
                  <li><i class="fa fa-check"></i>Where am I from?</li>
                  <li>
                    <i class="fa fa-check"></i>Why am here? i.e. your kingdom
                    purpose
                  </li>
                  <li>
                    <i class="fa fa-check"></i>What can I do? i.e. your
                    potential
                  </li>
                  <li>
                    <i class="fa fa-check"></i>Where am I going? i.e. your
                    destiny
                  </li>
                </ul>
                <p class="wow fadeInUp">
                  And these will lead to your success or failure here on earth
                  as a kingdom representative.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-cov></footer-cov>
  </div>
</template>
<script>
import FooterCov from "./FooterCoventry";

export default {
  components: {
    FooterCov
  },
  data() {
    return {};
  }
};
</script>
